/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoMalattiaDTO
 */
export interface AssistitoMalattiaDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaDTO
     */
    tipo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoMalattiaDTO interface.
 */
export function instanceOfAssistitoMalattiaDTO(value: object): value is AssistitoMalattiaDTO {
    return true;
}

export function AssistitoMalattiaDTOFromJSON(json: any): AssistitoMalattiaDTO {
    return AssistitoMalattiaDTOFromJSONTyped(json, false);
}

export function AssistitoMalattiaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoMalattiaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tipo': json['tipo'] == null ? undefined : json['tipo'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoMalattiaDTOToJSON(value?: AssistitoMalattiaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'tipo': value['tipo'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

